<div class="panel">
  <div class="col-12 payment-box d-flex justify-content-between align-items-center">
    <span>{{ 'AddressEdit' | translate }}</span>
    <img (click)="noAction()"
         class="cursor-pointer"
         src="/icons/close-circle.svg">
  </div>
  <div class="w-100 content-scroll overflow-y-auto overflow-x-hidden"
       style="max-height: 300px">
    <div class="row">
      <div class="col-12"
           style="margin-top: 10px">
        <app-frontend-map (addressDetail)="onAddressDetailReceived($event)"
                          [(latitudePointer)]="data.Latitude"
                          [(longitudePointer)]="data.Longitude"
                          [height]="'160px'"
                          [isAddressDetailEnable]="true"
                          [showControlsCurrentLocation]="!data.Latitude || !data.Longitude"
                          [width]="'100%'"></app-frontend-map>
      </div>
      <div class="col-md-6 mt-2">
        <label>{{ 'DeliveryRecipient' | translate }}</label>
        <app-frontend-input [(value)]="data.RecipientFullName"
                            class="input-style"></app-frontend-input>
      </div>
      <div class="col-md-6 mt-2">
        <label>{{ 'Mobile' | translate }}</label>
        <app-frontend-input [(value)]="data.Phone"
                            class="input-style"></app-frontend-input>
      </div>
      <div class="col-12 mt-2">
        <label>{{ 'AddressTitle' | translate }}</label>
        <app-frontend-input [(value)]="data.Title"
                            class="input-style"></app-frontend-input>
      </div>
      <div class="col-md-6 mt-2">
        <label>{{ 'Zone' | translate }}</label>
        <app-frontend-input [(value)]="data.Address"
                            class="input-style"></app-frontend-input>
      </div>
      <div class="col-md-6 mt-2">
        <label>{{ 'Address' | translate }}</label>
        <app-frontend-input [(value)]="data.Detail"
                            class="input-style"></app-frontend-input>
      </div>
      <div class="col-md-6 mt-2">
        <label>{{ 'PostCode' | translate }}</label>
        <app-frontend-input [(value)]="data.PostalCode"
                            class="input-style"></app-frontend-input>
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-center align-items-center"
       style="margin: 10px">
    <app-frontend-button (click)="onSubmitClicked()"
                         [title]="'Submit'"
                         class="w-100 input-style"></app-frontend-button>
  </div>
</div>
